import { createNamedContext } from '@trinity/chat-components/utils';

type ChatWelcomeScreenContextValue = {
  visible: boolean;
  enabled: boolean;
  dismiss: () => void;
  reset: () => void;
};

export const ChatWelcomeScreenContext = createNamedContext<ChatWelcomeScreenContextValue>(undefined, 'ChatWelcomeScreen.Context');